import React from 'react';

export default function PageLoader() {
  return (
    <div style={{ minHeight:'100vh', display:'flex', alignItems:'center', justifyContent:'center',
      background:'#fff', flexDirection:'column', gap:'16px' }}>
      <div style={{ width:'44px', height:'44px', border:'3px solid #e2e5ef',
        borderTopColor:'#1a56db', borderRadius:'50%', animation:'spin 0.8s linear infinite' }} />
      <p style={{ color:'#8a93b0', fontSize:'0.84rem', fontFamily:"'Plus Jakarta Sans',sans-serif", fontWeight:600 }}>Loading...</p>
      <style>{`@keyframes spin{from{transform:rotate(0deg)}to{transform:rotate(360deg)}}`}</style>
    </div>
  );
}
